import { type FC } from 'react';
import { Badge } from '@mantine/core';
import { formatOrder, payinOrderPublicStatusColors, type PayinOrderPublicStatus } from '~/entities/payin';

interface OrderStatusBadgeProps {
    status?: PayinOrderPublicStatus;
    fullWidth?: boolean;
}

export const OrderStatusBadge: FC<OrderStatusBadgeProps> = ({ status, fullWidth = false }) => {
    if (!status) {
        return null;
    }

    return (
        <Badge
            variant='dot'
            fullWidth={fullWidth}
            color={payinOrderPublicStatusColors[status]}
        >
            {formatOrder.publicStatus(status)}
        </Badge>
    );
};
